export enum KeySortError {
    InvalidInput = "Expected a plain object or array"
}
